<template>
  <li
    class="nav-item"
    :class="[getCurrentEventStatusClass(item), 
      isActive ? 'active' : null , 
      item.disabled ? disabled : null ,
      currentEventStatus(item) ? 'event-status-selected' : null,
      isVerticalMenuCollapsed ? 'nav-item-collapsed': null]"
  >
    <template v-if="item.logout">
      <b-link class="d-flex align-items-center" @click="onLogout" v-if="!isVerticalMenuCollapsed">
        <feather-icon :icon="item.icon || 'CircleIcon'" />
        <span class="menu-title text-truncate">{{ item.i18n ? $t('MAIN_MENU')[item.i18n] : item.title }}</span>
      </b-link>
      <b-link class="d-flex align-items-center" @click="onLogout" v-b-tooltip.hover.right="item.title" v-if="isVerticalMenuCollapsed">
        <feather-icon :icon="item.icon || 'CircleIcon'" />
      </b-link>
    </template>
    <template v-else-if="item.theme">
      <b-link class="d-flex align-items-center" @click="changeTheme" v-if="!isVerticalMenuCollapsed">
        <feather-icon :icon="getCurrentThemeIcon" />
        <span class="menu-title text-truncate">{{ getCurrentThemeName }}</span>
      </b-link>
      <b-link class="d-flex align-items-center" @click="changeTheme" v-b-tooltip.hover.right="getCurrentThemeName" v-if="isVerticalMenuCollapsed">
        <feather-icon :icon="getCurrentThemeIcon" />
      </b-link>
    </template>
    <template v-else-if="item.event_status">
      <b-link class="d-flex align-items-center menu-item-event-status" @click="selectEventStatus" v-if="!isVerticalMenuCollapsed">
        <feather-icon :icon="item.icon || 'CircleIcon'" />
        <span class="menu-title text-truncate">{{ item.i18n ? $t('MAIN_MENU')[item.i18n] : item.name }}</span>
        <div class="item-status">
          <b-badge pill class="badge-status">{{ item.total }}</b-badge>
        </div>
      </b-link>
      <b-link class="d-flex align-items-center" @click="selectEventStatus" v-b-tooltip.hover.right="item.name" v-if="isVerticalMenuCollapsed">
        <feather-icon :icon="item.icon || 'CircleIcon'" />
      </b-link>
    </template>
    <template v-else>
      <b-link v-bind="linkProps" class="d-flex align-items-center" v-if="!isVerticalMenuCollapsed">
        <feather-icon :icon="item.icon || 'CircleIcon'" />
        <span class="menu-title text-truncate">{{ item.i18n ? $t('MAIN_MENU')[item.i18n] : item.title }}</span>
        <b-badge
          v-if="item.tag"
          pill
          :variant="item.tagVariant || 'primary'"
          class="mr-1 ml-auto"
        >
          {{ item.tag }}
        </b-badge>
      </b-link>
      <b-link v-bind="linkProps" class="d-flex align-items-center" v-b-tooltip.hover.right="item.title" v-if="isVerticalMenuCollapsed">
        <feather-icon :icon="item.icon || 'CircleIcon'" />
        <b-badge
          v-if="item.tag"
          pill
          :variant="item.tagVariant || 'primary'"
          class="mr-1 ml-auto"
        >
          {{ item.tag }}
        </b-badge>
      </b-link>
    </template>
  </li>
</template>

<script>
// import { ref } from '@vue/composition-api'

import { BLink, BBadge, VBTooltip } from "bootstrap-vue";
import useVerticalNavMenuLink from "./useVerticalNavMenuLink";
import mixinVerticalNavMenuLink from "./mixinVerticalNavMenuLink";
import authService from "@/providers/authService";
import AppConstants from "@/appConstants";
import { EventBus } from '@/event-bus';

export default {
  components: {
    BLink,
    BBadge,
    /* eslint-disable */
    VBTooltip
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.currentUser || {};
    },
    isVerticalMenuCollapsed() {
      return this.$store.state.verticalMenu.isVerticalMenuCollapsed;
    },
    getCurrentThemeName() {
      if (this.currentUser.theme == AppConstants.THEME_DARK) {
        return "Tema Claro";
      }
      return "Tema Escuro";
    },
    getCurrentThemeIcon() {
      if (this.currentUser.theme == AppConstants.THEME_DARK) {
        return "SunIcon";
      }
      return "MoonIcon";
    },
    isCurrentManageNewsPath() {
      return this.$route.path == AppConstants.NAVIGATION_PAGE_MANAGE_NEWS;
    }
  },
  methods: {
    currentEventStatus(item) {
      if (item.event_status && this.isCurrentManageNewsPath) {
        return this.$store.state.manageNews.currentEventStatus.id == item.id;
      }
      return false;
    },
    getCurrentEventStatusClass(item) {
      switch (item.id) {
        case AppConstants.EVENT_STATUS.PUBLISHED:
          return 'event-status-published';
        case AppConstants.EVENT_STATUS.SAVED:
          return 'event-status-saved';
        case AppConstants.EVENT_STATUS.SCHEDULED:
          return 'event-status-scheduled';
        case AppConstants.EVENT_STATUS.CANCELED:
          return 'event-status-canceled';
        case AppConstants.EVENT_STATUS.EDITING:
          return 'event-status-editing';
        case AppConstants.EVENT_STATUS.DRAFT:
          return 'event-status-draft';
        case AppConstants.EVENT_STATUS.SHARED:
          return 'event-status-shared';
      }
      return null;
    },
    selectEventStatus() {
      console.log('selectEventStatus')
      this.$store.dispatch("manageNews/updateCurrentEventStatus", this.item);
      if (this.$route.path != AppConstants.NAVIGATION_PAGE_MANAGE_NEWS) {
        this.$router
          .push({
            path: AppConstants.NAVIGATION_PAGE_MANAGE_NEWS,
            query: { event_status: this.item.id },
          })
          .catch(() => {});
      }
      EventBus.$emit('current-event-status', this.item);
    },
    changeTheme() {
      if (this.currentUser.theme == AppConstants.THEME_DARK) {
        this.$store.dispatch("auth/updateTheme", AppConstants.THEME_LIGHT);
      } else {
        this.$store.dispatch("auth/updateTheme", AppConstants.THEME_DARK);
      }
      setTimeout(() => {
        this.$forceUpdate();
      }, 500);
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(
      props.item
    );

    const onLogout = () => {
      authService.logout();
    };

    return {
      isActive,
      linkProps,
      updateIsActive,
      onLogout,
    };
  },
};
</script>
